import { Injectable } from '@angular/core';
import { ScheduledJobWrapperService } from '@core/services/service-wrappers/scheduled-job-wrapper.service';
import { BaseGridSource, PagedModel } from 'components';
import { of } from 'rxjs';
import { catchError, finalize, map, take } from 'rxjs/operators';

@Injectable()
export class ScheduledJobsService extends BaseGridSource<any> {
  showDisabled = false;
  constructor(private service: ScheduledJobWrapperService) {
    super();
  }
  load(pagedModel: PagedModel) {
    if (!this.showDisabled) pagedModel.generalSearch = ""; else pagedModel.generalSearch = "disabled";
    this.savedPageModel = pagedModel;
    this.loadingSubject.next(true);

    this.service
      .apiV1ScheduledJobAllDetailPost(pagedModel)
      .pipe(
        map((response) => {
        
          this.itemCountSubject.next(response.metaData.totalItemCount);

          return response;
        }),
        catchError(() => of({ data: [] })),
        finalize(() => {
          this.loadingSubject.next(false);
        }),
        take(1)
      )
      .subscribe((data) => this.dataSourceSubject.next(data.data));
  }
}
